import { ChangeDetectionStrategy, Component, Injectable } from '@angular/core';
import { TablistService } from 'src/app/core/services/tablist.service';

@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-modal-task-bar',
  templateUrl: './modal-task-bar.component.html',
  styleUrls: ['./modal-task-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class  ModalTaskBarComponent {

  openTabs: any[] = [];
  constructor(
    protected tablistService: TablistService) 
  { 
    tablistService.arrayUpdated.subscribe((result:any) =>{
      this.openTabs = result; 
    })
  }

  openTab(elementId: string){
    var documentItem: any;
    this.tablistService.removeTab(elementId)
    documentItem = document.getElementById(`${elementId}`);
    documentItem!.className += " animateGrow openModal"
    documentItem!.classList.remove("miniModal");  
    documentItem = document.getElementsByClassName("noBackgroundForModal");
    documentItem.item(0).className += " static"
    documentItem.item(0).classList.remove("noBackgroundForModal");
  }
}
